
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./auth": () => {
return __webpack_require__.e(/*  | __federation_expose_auth */ "1511").then(() => (() => (__webpack_require__(9270))));
},
"./shellContext": () => {
return __webpack_require__.e(/*  | __federation_expose_shellContext */ "5900").then(() => (() => (__webpack_require__(69773))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };